
import { Component, Vue } from 'vue-property-decorator'

/**
 * パネル枠内の項目ボックス
 */
@Component
export default class ContentUnitBox extends Vue {
  /**
   * クリックイベントの発火を親コンポーネントに通知する
   *
   * @param event イベントオブジェクト
   */
  private clickEvent(event: Event): void {
    this.$emit('click', event)
  }
}
